import { Component } from "@angular/core";

@Component({
  selector: "iiq-external-app",
  template: `
    <nav-bar></nav-bar>
    <main class="flex grow justify-center">
      <router-outlet></router-outlet>
    </main>
    <footer class="footer">
      &copy; Western Governors University
    </footer>
  `,
})
export class IIQExternalAppComponent {
  title = "iiq-external-app";
}
